export const emailCaseCorrect = (email: string) => {
    return email.toLowerCase();
};

export const formatPhoneNumber = (phone: string) => {
    // Removed country code from phone number
    return (
        phone &&
        phone
            .replace(/\D/g, '')
            .slice(-10)
            .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    );
};

export const formattedInventoryDate = (inventoryDate = '') => {
    return inventoryDate ? new Date(inventoryDate).toISOString().substring(0, 10) : '';
};
